<template>
    <div class="relative flex flex-col max-w-screen-xl mx-auto pl-5 lg:pl-12 pr-5 py-5 lg:py-12">

        <lead-header :show-location-selector="false">
            Did You Receive a Ticket within the Past 90 Days?
        </lead-header>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-10 text-center">
            <label
                class="flex-1 flex items-center border accent-brand-blue rounded-md p-4 whitespace-nowrap"
                :class="[ answer === true ? 'border-brand-blue bg-brand-blue/10' : 'border-zinc-200 bg-transparent' ]"
            >
                <input class="w-8 h-8" type="radio" :value="true" name="overridden_division_slug" v-model="answer" @change="form.errors.clear($event.target.name)">
                <span class="ml-4 font-medium text-lg">Yes</span>
            </label>
            <label
                class="flex-1 flex items-center border accent-brand-blue rounded-md p-4 whitespace-nowrap"
                :class="[ answer === false ? 'border-brand-blue bg-brand-blue/10' : 'border-zinc-200 bg-transparent' ]"
            >
                <input class="w-8 h-8" type="radio" :value="false" name="overridden_division_slug" v-model="answer" @change="form.errors.clear($event.target.name)">
                <span class="ml-4 font-medium text-lg">No</span>
            </label>
        </div>

        <div v-if="form.errors.has('traffic_qualifying_question')" class="py-4 text-center text-red-500" role="alert">
            <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>

            <span class="sr-only">
                Error:
            </span>

            {{ form.errors.get('traffic_qualifying_question') }}
        </div>

        <div class="mt-5 lg:mt-6 flex flex-col lg:flex-row justify-between w-full items-center">
            <previous-button></previous-button>

            <next-button
                type="button"
                role="button"
                id="btn-lead-capture-step-qualify"
                @click.native="submit"
            >
                Continue
            </next-button>
        </div>
    </div>
</template>

<script>
import { set } from 'lodash';
import { mapGetters } from 'vuex';

import PreviousButton from '../PreviousButton.vue';
import NextButton from '../NextButton.vue';
import LeadFooter from '../LeadFooter.vue';
import LeadHeader from "../LeadHeader.vue";
export default {
    props: {
        division: {
            type: String,
            required: true,
        }
    },
    data: () => {
        return {
            answer: null,
        };
    },
    components: {
        PreviousButton,
        NextButton,
        LeadHeader,
        LeadFooter,
    },
    computed: {
        ...mapGetters('lead', [
            'form',
        ]),
    },
    methods: {
        /**
         * Check if question is required for this Submission.
         *
         * @returns {boolean}
         */
        isApplicable() {
            return ['traffic'].includes(this.division);
        },
        /**
         * Check if form is valid and set respective errors if needed.
         *
         * @returns {boolean}
         */
        formIsValid() {
            if (this.answer === null) {
                this.$set(this.form.errors.errors, 'traffic_qualifying_question', ['Required, please select an option.']);
                return false;
            }
            return true;
        },
        /**
         * Record necessary Submission information in local storage.
         */
        recordInLocalStorage() {
            let form = JSON.parse(window.localStorage.getItem('lcsForm'));
            set(form, 'overridden_division_slug', this.form.overridden_division_slug);
            set(form, 'overriding_question', this.form.overriding_question);
            window.localStorage.setItem('lcsForm', JSON.stringify(form));
        },
        /**
         * Record data in localStorage and fire event that this step is done.
         */
        submit() {
            if (this.formIsValid()) {
                if (this.answer === false) {
                    this.form.overridden_division_slug = 'unserviceable';
                    this.form.overriding_question = 'traffic';
                } else {
                    this.form.overridden_division_slug = null;
                    this.form.overriding_question = null;
                }

                this.recordInLocalStorage();
                window.dataLayer.push({
                    event: 'form_step_submit',
                    form_step_id: window.getCurrentStep(),
                    form_step_name: 'qualify'
                });
                this.$event.$emit('step:next');
            }
        },
    },
    mounted() {
        if (!this.isApplicable()) {
            this.$emit('skip');
            return;
        } else {
            this.form.has_qualifying_question = true;
        }


        window.dataLayer.push({
            event: 'form_step_mounted',
            form_step_id: window.getCurrentStep(),
            form_step_name: 'qualify'
        });
    }
};
</script>
